import React, { useState } from "react";

import { Button } from "../../ui/button";
import { resetUserPassword } from "../../../services/adminApi";
import { errMsg } from "../../../lib/errMsg";

export const ResetPasswordSection: React.FC<{ uid: number; token: string }> = ({ uid, token }) => {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  const submit = async () => {
    if (pw.length < 8) {
      setMsg({ ok: false, text: "Password must be at least 8 characters." });
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      await resetUserPassword(uid, pw, token);
      setPw("");
      setMsg({ ok: true, text: "Password reset. Share it with the user securely." });
    } catch (e) {
      setMsg({ ok: false, text: errMsg(e) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-end gap-2">
        <input
          type="text"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="new password (8+ chars)"
          autoComplete="new-password"
          className="flex-1 text-sm border border-secondary-300 rounded px-2 py-1"
        />
        <Button variant="outline" size="sm" disabled={busy || !pw} onClick={() => void submit()}>
          {busy ? "Resetting…" : "Reset password"}
        </Button>
      </div>
      {msg && (
        <div className={`text-[11px] ${msg.ok ? "text-success-700" : "text-error-700"}`}>
          {msg.text}
        </div>
      )}
      <div className="text-[11px] text-secondary-500">
        Sets a new password immediately (bcrypt). The user isn't emailed — hand it over securely.
      </div>
    </div>
  );
};
